export const RECEIVED_PAYMENTS_FIELDS = ['id', 'name', 'purpose'];
